import React from 'react';
import PropTypes from 'prop-types';

import cx from 'classnames';

export default class TrustboxEmbed extends React.PureComponent {
  static propTypes = {
    locale: PropTypes.string.isRequired,
    domain: PropTypes.string.isRequired,
    templateId: PropTypes.string.isRequired,
    businessUnitId: PropTypes.string.isRequired,
    schemaType: PropTypes.string,
    stars: PropTypes.string,
    className: PropTypes.string,
    theme: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string
  };

  constructor(props) {
    super(props);

    this._containerRef = React.createRef();
  }

  componentDidMount() {
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(this._containerRef.current);
    }
  }

  componentDidUpdate() {
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(this._containerRef.current);
    }
  }

  render() {
    const {
      className,
      domain, locale, templateId, businessUnitId, stars, schemaType, theme, width, height
    } = this.props;

    return (
      <div
        className={cx('trustpilot-widget', className)}
        data-locale={locale}
        data-template-id={templateId}
        data-businessunit-id={businessUnitId}
        data-stars={stars}
        data-schema-type={schemaType}
        data-theme={theme}
        data-style-height={height} data-style-width={width}
        ref={this._containerRef}
        key={`${businessUnitId}-${templateId}-${stars}-${theme}-${domain}`}
      >
        <a href={`https://www.trustpilot.com/review/${domain}`} target="_blank" rel="nofollow">Trustpilot</a>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/embeds/TrustboxEmbed.js